import { useEffect } from 'react'
import { useChatPanel } from '../contexts/ChatPanelContext'
import { ChatList } from './ChatList'
import './ChatPanel.css'

export function ChatPanel() {
  const { isOpen, closePanel } = useChatPanel()

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        closePanel()
      }
    }
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, closePanel])

  if (!isOpen) return null

  return (
    <>
      <div className="chat-panel-overlay" onClick={closePanel} />
      <div className={`chat-panel ${isOpen ? 'open' : ''}`}>
        <div className="chat-panel-header">
          <h2>Chat</h2>
          <button
            className="chat-panel-close"
            onClick={closePanel}
            aria-label="Close chat panel"
            title="Close"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="chat-panel-body">
          <ChatList />
        </div>
      </div>
    </>
  )
}
































